import http from "@/services/http";

export async function getOktaProfile(email: string) {
  const { data } = await http().get(
    window.env.PERMISSION_SERVICE_URL + "/user-profile/validate/" + email
  );
  return data;
}
